// extracted by mini-css-extract-plugin
export var content = "_o3-1";
export var noScroll = "_o3-3";
export var paper = "_o3-0";
export var scrollable = "_o3-2";